/* Our Team Page - Static Content Constants */

export const OUR_TEAM_PAGE_CONTENT = Object.freeze({
  PAGE_TITLE: "People behind the impact",
  PAGE_DESCRIPTION: "IMA is a dedicated collective of professionals committed to shaping a vibrant community of business leaders—driven by insightful research, trusted executive counselling, and meaningful peer engagement.",
  SECTION_TITLE: "Leadership",
  BREADCRUMBS: [
    { label: "About", href: "/about_ima" },
    { label: "Our team", href: "/about_ima/our-team" }
  ]
});


